import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {EmMarkdownPipe, TranslationService} from '@emma-labs/shared/angular';
import {
  EXTRA_REQUIREMENTS_TRANSLATIONS,
  ExtraRequirement,
  ExtraRequirementsInquiry,
} from '@emma-labs/shared/typescript';
import {getDateFormat} from '../utils';

@Component({
  selector: 'em-extra-requirements-inquiries',
  imports: [CommonModule, EmMarkdownPipe],
  templateUrl: './extra-requirements-inquiries.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtraRequirementsInquiriesComponent {
  dateFormat: string;

  @Input({required: true}) extraRequirementsInquiries: ExtraRequirementsInquiry[] = [];

  constructor(private readonly translate: TranslationService) {
    this.dateFormat = getDateFormat(translate.getCurrentLanguageCode());
  }

  translateExtraRequirements(extraRequirement: ExtraRequirement[]): string {
    const lang = this.translate.getCurrentLanguageCode();
    return extraRequirement
      .map((requirement) => EXTRA_REQUIREMENTS_TRANSLATIONS[requirement][lang])
      .join(', ');
  }
}
